






















































import { defineComponent, reactive, toRefs, onMounted } from '@vue/composition-api';
import ProcessModel from '@/components/ProcessModel/index.vue';
import Clounms from '@/components/Cloumns/index.vue';
import titleBox from '@/components/Box/index.vue';
import Pagination from '@/components/Pagination';
import request from '@utils/request';
import addComma from '@/utils/addComma';
import { isCore  } from '@/useable/login';
import svgCom from '@components/Svg/index';

export default defineComponent({
  name: 'billDetail',
  components: {
    Clounms,
    titleBox,
    Pagination,
    ProcessModel,
    svgCom
  },
  setup(props: any, { root }: any){
    const state = reactive({
      loginstatus: false,
      total: 0,
      pageSize: 10,
      page: 1,
      orderNo:'',
      tableConfig: {
        column: [
          {key: 'orderNo', label: '付款单号'},
          {key: 'operateTime', label: '处理时间'},
          {key: 'companyName', label: '处理方'},
          {key: 'operator', label: '处理人'},
          {key: 'operateName', label: '处理步骤'},
          {key: 'contentDesc', label: '内容备注'}
        ],
        data: []
      },
      processData:[
        {
          title:'付款单提交',
          date:'',
          time:'',
          num:1,
          choose:false
        },
        {
          title:'发票已签收',
          date:'',
          time:'',
          num:2,
          choose:false
        },
        {
          title:'发票审核',
          date:'',
          time:'',
          num:3,
          choose:false
        },
        {
          title:'推送付款',
          date:'',
          time:'',
          num:4,
          choose:false
        },
        {
          title:'已收款',
          date:'',
          time:'',
          num:5,
          choose:false
        }
      ],
      formSupplierColumn: [
        {
          name: 'companyName',
          type: 'input',
          label: '企业名称：',
          disabled: true,
          placeholder: '',
        },
        {
          name: 'paymentSlipStatus',
          type: 'select',
          label: '付款单状态：',
          placeholder: '',
          options: [
            {
              name: '全部',
              value: ''
            },
            {
              name: '付款单提交',
              value: '0'
            },
            {
              name: '发票已签收',
              value: '1'
            },
            {
              name: '发票审核',
              value: '2'
            },
            {
              name: '推送付款',
              value: '3'
            },
            {
              name: '已收款',
              value: '4'
            }
          ]
        },
        {
          name: 'paymentSlipNumber',
          type: 'input',
          label: '付款单号：',
          placeholder: '输入结算单号',
          options: [],
        }
      ],
      cloumnsData: [
        {
          title:'付款企业',
          value:''
        },
        {
          title:'收款企业',
          value:''
        },
        {
          title:'付款类型',
          value:''
        },
        {
          title:'付款单号',
          value:''
        },
        {
          title:'付款金额',
          value:''
        },
        {
          title:'付款单状态',
          value:''
        },
        {
          title:'融资状态',
          value:''
        },
        {
          title:'融资申请单号',
          value:''
        },
        {
          title:'预计付款日期',
          value:''
        }
      ],
    });
    const getBillDetail = async () => {
      const res = await request('bill', 'getBillDetail', {
        orderNo: root.$route.params.orderNo
      });
      if (res.code === 2000) {
        const result = res.data;
        state.cloumnsData[0].value = result.payCorpName;
        state.cloumnsData[1].value = result.supplierName;
        state.cloumnsData[2].value = result.orderTypeName;
        state.cloumnsData[3].value = result.orderNo;
        state.cloumnsData[4].value = addComma(result.amount) + result.currency;
        state.cloumnsData[5].value = result.orderStatusName;
        state.cloumnsData[6].value = result.financeStatusName;
        state.cloumnsData[7].value = result.financeOrderNo; 
        state.cloumnsData[8].value = result.planPayTime; 
        state.orderNo = result.orderNo;
        const processLen = state.processData.length;
        for (let i= 0;i < processLen; i++){
          if (i===processLen-1 && result.orderStatusName === '付款失败') {
            state.processData[i].title = '付款失败';
            state.processData[i].choose = true;
            break;
          } else if (i===processLen-1 && result.orderStatusName === '已收款') {
            state.processData[i].title = '已收款';
          }
          if (state.processData[i].title === result.orderStatusName){
            state.processData[i].choose = true;
            state.processData[i].date = getDate(result, i);
            state.processData[i].time = getTime(result, i);
            break;
          } else {
            state.processData[i].choose = true;
            state.processData[i].date = getDate(result, i);
            state.processData[i].time = getTime(result, i);
          }
        }
      }
    };
    const getDate = (data, index) => {
      switch (index) {
        case 0:
          return data.orderApplyTime?data.orderApplyTime.split(' ')[0]:'';
          break;
        case 1:
          return data.invoiceReceiveTime?data.invoiceReceiveTime.split(' ')[0]:'';
          break;
        case 2:
          return data.invoiceConfirmTime?data.invoiceConfirmTime.split(' ')[0]:'';
          break;
        case 3:
          return data.postPayTime?data.postPayTime.split(' ')[0]:'';
          break;
        case 4:
          return data.paidTime?data.paidTime.split(' ')[0]:'';
          break;
        case 5:
          return data.operateTime?data.operateTime.split(' ')[0]:'';
          break;
        default:
				  return data.orderApplyTime?data.orderApplyTime.split(' ')[0]:'';
          break;
      }
    };
    const getTime = (data, index) => {
      switch (index) {
        case 0:
          return data.orderApplyTime?data.orderApplyTime.split(' ')[1]:'';
          break;
        case 1:
          return data.invoiceReceiveTime?data.invoiceReceiveTime.split(' ')[1]:'';
          break;
        case 2:
          return data.invoiceConfirmTime?data.invoiceConfirmTime.split(' ')[1]:'';
          break;
        case 3:
          return data.postPayTime?data.postPayTime.split(' ')[1]:'';
          break;
        case 4:
          return data.paidTime?data.paidTime.split(' ')[1]:'';
          break;
        case 5:
          return data.operateTime?data.operateTime.split(' ')[1]:'';
          break;
        default:
				  return data.orderApplyTime?data.orderApplyTime.split(' ')[1]:'';
          break;
      }
    };
    const getBillLogList = async () => {
      const res = await request('bill', 'getBillLogList', {
        orderNo: root.$route.params.orderNo,
        current: state.page,
        size: state.pageSize
      });
      if (res.code === 2000) {
        state.tableConfig.data = res.data.records;
        const configRes = res.data.records.find(i=>i.operateName==='付款失败');
        if (configRes){
          state.processData[state.processData.length-1].date = getDate(configRes, 5);
          state.processData[state.processData.length-1].time = getTime(configRes, 5);
        }
        state.total = res.data.total;
      }
    };
    const ApplyForFinancing = async () => {
      root.$router.push({
        path: '/Financing/edit/editOne'
      }); 
    };
    if (isCore.value){
      state.loginstatus = true;
    } else {
      state.loginstatus = false;
    }
    getBillLogList();
    getBillDetail();
    const back = () => {
      history.go(-1);   
    };
    const pageChange = (newPage, newSize) => {
      state.page = newPage;
      state.pageSize = newSize;
      submit();
    };
    const submit = () => {
      const parms = {
        // ...state.form,
        currentPage: state.page,
        pageSize: state.pageSize,
      };
    };
    onMounted(submit);
    return {
      ...toRefs(state),
      ApplyForFinancing,
      pageChange,
      getBillDetail,
      back
    };
  }
});
